const BASE = '/api/democracy';
const ADMIN = `${BASE}/admin`;
const PUBLIC = `${BASE}/public`;

export const Endpoints = {
    publicInfo: `${PUBLIC}/info`,

    democracies: {
        list: `${ADMIN}/democracies`,
        create: `${ADMIN}/democracies`,
        get: (id) => `${ADMIN}/democracies/${id}`,
        update: (id) => `${ADMIN}/democracies/${id}`,
        delete: (id) => `${ADMIN}/democracies/${id}`,
        updateStatus: (id) => `${ADMIN}/democracies/${id}/status`,
        bundleDownload: (id) => `${ADMIN}/democracies/${id}/bundle.zip`,
        systemSounds: (id) => `${ADMIN}/democracies/${id}/system-sounds`,
        systemSoundsKind: (id, kind) => `${ADMIN}/democracies/${id}/system-sounds/${kind}`,
    },

    rounds: {
        listForDemocracy: (democracyId) => `${ADMIN}/democracies/${democracyId}/rounds`,
        createForDemocracy: (democracyId) => `${ADMIN}/democracies/${democracyId}/rounds`,
        update: (id) => `${ADMIN}/rounds/${id}`,
        delete: (id) => `${ADMIN}/rounds/${id}`,
        reorder: (democracyId) => `${ADMIN}/democracies/${democracyId}/rounds/reorder`,
    },

    questions: {
        listForRound: (roundId) => `${ADMIN}/rounds/${roundId}/questions`,
        createForRound: (roundId) => `${ADMIN}/rounds/${roundId}/questions`,
        update: (id) => `${ADMIN}/questions/${id}`,
        delete: (id) => `${ADMIN}/questions/${id}`,
        reorder: (roundId) => `${ADMIN}/rounds/${roundId}/questions/reorder`,
    },

    sanctions: {
        listForDemocracy: (democracyId) => `${ADMIN}/democracies/${democracyId}/sanctions`,
        createForDemocracy: (democracyId) => `${ADMIN}/democracies/${democracyId}/sanctions`,
        types: `${ADMIN}/sanctions/types`,
        effects: `${ADMIN}/sanctions/effects`,
        update: (id) => `${ADMIN}/sanctions/${id}`,
        delete: (id) => `${ADMIN}/sanctions/${id}`,
    },

    teams: {
        listForDemocracy: (democracyId) => `${ADMIN}/democracies/${democracyId}/teams`,
        createForDemocracy: (democracyId) => `${ADMIN}/democracies/${democracyId}/teams`,
        update: (id) => `${ADMIN}/teams/${id}`,
        delete: (id) => `${ADMIN}/teams/${id}`,
        reorder: (democracyId) => `${ADMIN}/democracies/${democracyId}/teams/reorder`,
        regenerateJoinCode: (id) => `${ADMIN}/teams/${id}/regenerate-join-code`,
        importFromCamp: (democracyId) => `${ADMIN}/democracies/${democracyId}/teams/import-from-camp`,
        passAudio: (id) => `${ADMIN}/teams/${id}/pass-audio`,
        answerAudio: (id) => `${ADMIN}/teams/${id}/answer-audio`,
    },

    sessions: {
        get: (id) => `${ADMIN}/sessions/${id}`,
        controls: {
            showQuestion: (id) => `${ADMIN}/sessions/${id}/controls/show-question`,
            hideQuestion: (id) => `${ADMIN}/sessions/${id}/controls/hide-question`,
            showAnswer: (id) => `${ADMIN}/sessions/${id}/controls/show-answer`,
            hideAnswer: (id) => `${ADMIN}/sessions/${id}/controls/hide-answer`,
            showRating: (id) => `${ADMIN}/sessions/${id}/controls/show-rating`,
            hideRating: (id) => `${ADMIN}/sessions/${id}/controls/hide-rating`,
            showRoundDescription: (id) => `${ADMIN}/sessions/${id}/controls/show-round-description`,
            hideRoundDescription: (id) => `${ADMIN}/sessions/${id}/controls/hide-round-description`,
            showMedia: (id) => `${ADMIN}/sessions/${id}/controls/show-media`,
            hideMedia: (id) => `${ADMIN}/sessions/${id}/controls/hide-media`,
            selectMedia: (id) => `${ADMIN}/sessions/${id}/controls/select-media`,
            startTimer: (id) => `${ADMIN}/sessions/${id}/controls/start-timer`,
            pauseTimer: (id) => `${ADMIN}/sessions/${id}/controls/pause-timer`,
            nextQuestion: (id) => `${ADMIN}/sessions/${id}/controls/next-question`,
            selectQuestion: (id) => `${ADMIN}/sessions/${id}/controls/select-question`,
            nextRound: (id) => `${ADMIN}/sessions/${id}/controls/next-round`,
            selectRound: (id) => `${ADMIN}/sessions/${id}/controls/select-round`,
            nextTeam: (id) => `${ADMIN}/sessions/${id}/controls/next-team`,
            selectTeam: (id) => `${ADMIN}/sessions/${id}/controls/select-team`,
            throwQuestion: (id) => `${ADMIN}/sessions/${id}/controls/throw-question`,
            applyCorrectAnswer: (id) => `${ADMIN}/sessions/${id}/controls/apply-correct-answer`,
        },
        teamRuntime: (id, teamId) => `${ADMIN}/sessions/${id}/teams/${teamId}/runtime`,
        teamExclude: (id, teamId) => `${ADMIN}/sessions/${id}/teams/${teamId}/exclude`,
        teamSanctionDelete: (id, teamId, sanctionId) =>
            `${ADMIN}/sessions/${id}/teams/${teamId}/sanctions/${sanctionId}`,
        sanctionBuy: (id) => `${ADMIN}/sessions/${id}/sanctions/buy`,
    },

    bundle: {
        upload: `${ADMIN}/bundle/upload`,
    },
};

export const WsTopic = {
    controls: (democracyId) => `/topic/democracy/${democracyId}/controls`,
    team: (democracyId, teamId) => `/topic/democracy/${democracyId}/team/${teamId}`,
    sound: (democracyId) => `/topic/democracy/${democracyId}/sound`,
    preStart: (democracyId) => `/topic/democracy/${democracyId}/pre-start`,
};

export const WsEventType = {
    CONTROLS_DATA: 'CONTROLS_DATA',
    TIME: 'TIME',
    PRE_START_TIME: 'PRE_START_TIME',
    SOUND: 'SOUND',
    CUSTOM_SOUND: 'CUSTOM_SOUND',
    TASK_NEW: 'TASK_NEW',
    TASK_DURATION_CHANGED: 'TASK_DURATION_CHANGED',
    TASK_END: 'TASK_END',
    TIME_EXPIRED: 'TIME_EXPIRED',
    ACTION_EXCEPTION: 'ACTION_EXCEPTION',
};

export const DemocracyStatus = {
    DEVELOP: 'DEVELOP',
    WAITING_ACTIVE: 'WAITING_ACTIVE',
    ACTIVE: 'ACTIVE',
    FINISHED: 'FINISHED',
};

export const DemocracyStatusLabel = {
    [DemocracyStatus.DEVELOP]: 'В разработке',
    [DemocracyStatus.WAITING_ACTIVE]: 'Ожидание',
    [DemocracyStatus.ACTIVE]: 'Активна',
    [DemocracyStatus.FINISHED]: 'Завершена',
};

export const QuestionType = {
    SIMPLE: 'SIMPLE',
    KAHOOT: 'KAHOOT',
};

export const SanctionType = {
    SINGLE: 'SINGLE',
    TEAM: 'TEAM',
    CONDITIONS_BEFORE_ANSWER: 'CONDITIONS_BEFORE_ANSWER',
    RESPONSE_CONDITIONS: 'RESPONSE_CONDITIONS',
    SCREEN: 'SCREEN',
};

export const SanctionTypeLabel = {
    [SanctionType.SINGLE]: 'Одному игроку',
    [SanctionType.TEAM]: 'На всю команду',
    [SanctionType.CONDITIONS_BEFORE_ANSWER]: 'Перед ответом',
    [SanctionType.RESPONSE_CONDITIONS]: 'При ответе',
    [SanctionType.SCREEN]: 'На экране',
};

export const SanctionEffect = {
    NONE: 'NONE',
    ROTATE: 'ROTATE',
    FULL_ROTATE: 'FULL_ROTATE',
    CRAZY_ANIMATION: 'CRAZY_ANIMATION',
    REMOVE_VOWELS: 'REMOVE_VOWELS',
    REMOVE_CONSONANTS: 'REMOVE_CONSONANTS',
    REVERSE_STRING: 'REVERSE_STRING',
    SWAP_ADJACENT_WORDS: 'SWAP_ADJACENT_WORDS',
};

export const SanctionEffectLabel = {
    [SanctionEffect.NONE]: 'Без эффекта',
    [SanctionEffect.ROTATE]: 'Перевернуть',
    [SanctionEffect.FULL_ROTATE]: 'Полное вращение',
    [SanctionEffect.CRAZY_ANIMATION]: 'Хаотичная анимация',
    [SanctionEffect.REMOVE_VOWELS]: 'Убрать гласные',
    [SanctionEffect.REMOVE_CONSONANTS]: 'Убрать согласные',
    [SanctionEffect.REVERSE_STRING]: 'Задом наперёд',
    [SanctionEffect.SWAP_ADJACENT_WORDS]: 'Поменять соседние слова',
};

export const SystemSoundKind = {
    NO_ANSWER: 'NO_ANSWER',
    NEW_SANCTION: 'NEW_SANCTION',
    PRE_START_TIMER: 'PRE_START_TIMER',
};

export const FileExtensionType = {
    IMAGE: 'IMAGE',
    AUDIO: 'AUDIO',
    VIDEO: 'VIDEO',
    UNDEF: 'UNDEF',
};

export const DemocracyMode = {
    K8S: 'k8s',
    STANDALONE: 'standalone',
};

export const TeamImportItemStatus = {
    IMPORTED: 'IMPORTED',
    SKIPPED_DUPLICATE_NAME: 'SKIPPED_DUPLICATE_NAME',
};

export const TeamImportItemStatusLabel = {
    [TeamImportItemStatus.IMPORTED]: 'Импортировано',
    [TeamImportItemStatus.SKIPPED_DUPLICATE_NAME]: 'Пропущено: имя уже занято',
};

export const BusinessErrorCode = {
    CANNOT_BUY_FOR_SELF: 'CANNOT_BUY_FOR_SELF',
    TEAM_SESSION_INVALID: 'TEAM_SESSION_INVALID',
    BUNDLE_DOWNLOAD_DISABLED_IN_STANDALONE: 'BUNDLE_DOWNLOAD_DISABLED_IN_STANDALONE',
    DEMOCRACY_NOT_FOUND: 'DEMOCRACY_NOT_FOUND',
    JOIN_CODE_UNKNOWN: 'JOIN_CODE_UNKNOWN',
    STATUS_TRANSITION_INVALID: 'STATUS_TRANSITION_INVALID',
    SESSION_NOT_RUNNING: 'SESSION_NOT_RUNNING',
    SESSION_NOT_IN_DEVELOP: 'SESSION_NOT_IN_DEVELOP',
    ORDER_ID_TAKEN: 'ORDER_ID_TAKEN',
    INSUFFICIENT_BALANCE: 'INSUFFICIENT_BALANCE',
    SANCTION_TYPE_ALREADY_ACTIVE: 'SANCTION_TYPE_ALREADY_ACTIVE',
    MAX_CONCURRENT_SANCTIONS: 'MAX_CONCURRENT_SANCTIONS',
    KAHOOT_ONLY_SCREEN_SANCTIONS: 'KAHOOT_ONLY_SCREEN_SANCTIONS',
    OPTIMISTIC_LOCK: 'OPTIMISTIC_LOCK',
    LAST_QUESTION_REACHED: 'LAST_QUESTION_REACHED',
    BUNDLE_INCOMPLETE: 'BUNDLE_INCOMPLETE',
    RATE_LIMIT_EXCEEDED: 'RATE_LIMIT_EXCEEDED',
    IMPORT_NOT_AVAILABLE_IN_STANDALONE: 'IMPORT_NOT_AVAILABLE_IN_STANDALONE',
    CAMP_DOMAIN_UNAVAILABLE: 'CAMP_DOMAIN_UNAVAILABLE',
    INVALID_DEMOCRACY_STATUS: 'INVALID_DEMOCRACY_STATUS',
    INVALID_MEDIA_TYPE: 'INVALID_MEDIA_TYPE',
};

export const QueryKey = {
    publicInfo: ['democracy', 'public-info'],
    democracy: (campScopeKey) => ['democracy', 'current', campScopeKey],
    democracyFull: (id) => ['democracy', 'full', id],
    rounds: (democracyId) => ['democracy', 'rounds', democracyId],
    sanctions: (democracyId) => ['democracy', 'sanctions', democracyId],
    sanctionTypes: ['democracy', 'sanction-types'],
    sanctionEffects: ['democracy', 'sanction-effects'],
    teams: (democracyId) => ['democracy', 'teams', democracyId],
    session: (democracyId) => ['democracy', 'session', democracyId],
};

export const Defaults = {
    timeBudgetSeconds: 180,
    teamColor: '#888888',
    initialBalance: 0,
    initialRating: 0,
    sanctionMaxConcurrent: 1,
    sanctionDuration: 1,
};
